import Options from "../utils/ui_controls";
import './module_filters.css'
import React from "react";


const Filter = ({name, title, type, options, defaults, onChange}) => {
    //console.log("Filter", name, defaults)
    switch(type) {
        case "list":
            return <span className={"filter"}>
                <label>{title}</label>
                <textarea name={name} onBlur={onChange} defaultValue={defaults}></textarea>
            </span>
        case "select-multiple":
            return <span className={"filter"}>
                <label>{title}</label>
                <select name={name} multiple={true} onChange={onChange} defaultValue={defaults}>
                    <Options options={options} />
                </select>
            </span>
        case "select":
            return <span className={"filter"}>
                <label>{title}</label>
                <select name={name} onChange={onChange} defaultValue={defaults}>
                    <Options options={options} defaults={defaults}/>
                </select>
            </span>
        default:
            return <span className={"filter"}>
                <label>{title}</label>
                <input name={name} onBlur={onChange} defaultValue={defaults}/>
            </span>
    }
}

const ModuleFilters = ({filters, onChange, className}) => {

    const onSingleChange = (e) => {
        const change = {
            name:   e.target.name,
            value: ''
        }
        switch(e.target.type) {
            case 'textarea':
                change.value = e.target.value.split(/[\s,]+/)
                break;
            case 'select':
            case 'select-multiple':
                const hasSelectedItems = !!e.target.selectedOptions.length
                if(hasSelectedItems){
                    change.value = Array.from(e.target.selectedOptions, option => option.value)
                }else{ //nothing selected - put all options on
                    change.value = Array.from(e.target.options, option => option.value)
                }

                break
            default:
                change.value = e.target.value
        }
        console.log("onSingleChange", change)
        onChange(change)
    }

    const filterNames = Object.keys(filters).sort()

    return filterNames.length ?
        <div className={`filters ${className}`}>{filterNames.map(
        (name, i) => <Filter
            id={filters[name].id}
            key={i}
            name={name}
            title={name.replaceAll('_',' ')}
            type={filters[name].type}
            defaults={filters[name].default}
            options={filters[name].options}
            onChange={onSingleChange}
        />
    )}</div> : null
}


export default ModuleFilters

